import { render } from "./NewContact.vue?vue&type=template&id=37edc652"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/NewContact.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37edc652"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37edc652', __exports__)) {
    api.reload('37edc652', __exports__)
  }
  
  module.hot.accept("./NewContact.vue?vue&type=template&id=37edc652", () => {
    api.rerender('37edc652', render)
  })

}


export default __exports__